export const LARGEST_SIZE = 32;
export const LARGE_SIZE = 28;
export const HEADING_SIZE = 24;
export const SUBHEADING_SIZE = 22;
export const BIG_SIZE = 20;
export const NORMAL_SIZE = 18;
export const SMALL_SIZE = 16;
export const TAB_ICON_WIDTH = 30;
export const TAB_ICON_HEIGHT = 30;
export const MCQ_QUESTION_TEXT_SIZE = 18;
export const MCQ_QUESTION_SUBTEXT_SIZE = 16;

//Box sizing constants
export const SPACE_BETWEEN_SCREEN_EDGE_AND_CONTENTS = 20;
export const ACTION_BAR_HEIGHT = 60;


